import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import WaterContainerItem from "./WaterContainerItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_WATER_CONTAINERS, ON_UPDATED_WATER_PALLET} from "../../../queries/inventory";

class WaterContainersList extends Component {

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.subscription && !nextProps.loading) {
      this.subscription = this.props.subscribeToUpdates(this.props, {});
    }
  }

  render() {
    let {loading, error, palletWaterContainers} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "Serial Nr.",
      "SKU",
      "State",
    ]);

    return (
      <Table
        data={fromJS(palletWaterContainers)}
        tableHeader={tableHeader}
        renderer={WaterContainerItem}
        selected={this.props.selectedId}
        onItemClick={this.handleItemClick.bind(this)}
        itemKey="serial"
        mode="table" />
    )
  }

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("serial");
    let sku = itemData.get("sku");
    this.props.onSelectionChange(id, sku);
  }
}


const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_WATER_PALLET,
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }  
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_WATER_CONTAINERS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      palletId: props.palletId
    }
  })
})

export default withQuery(withSubscription(WaterContainersList));